import { trpc } from '@/lib/trpc';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

const useFeedback = () => {
	const { t } = useTranslation();
	const { mutate } = trpc.user.feedback.useMutation({
		onMutate: () => {
			toast.success(t('feedback.form.success'));
		},
	});

	return { sendFeedback: mutate };
};

export default useFeedback;
